import React from "react";
import {
  faTimes,
  faUser,
  faCopy,
  faShieldAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

const MeetingInfoBlock = styled.div`
  position: absolute;
  top: 50px;
  left: 50px;
  background-color: #191919;
  border-radius: 10px;
  padding: 25px;
  z-index: 99;
  width: 310px;
  .meeting-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #eeee;
  }
  h3 {
    margin: 0;
    margin-bottom: 5px;
    font-size: 1.2rem;
    font-weight: 600;
  }
  .icon {
    cursor: pointer;
    font-size: 1.3rem;
  }
  .add-people-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #eeee;
    color: #000;
    font-size: 16px;
    font-family: "Comic Neue", cursive;
    border: none;
    padding: 8px 12px;
    border-radius: 5px;
    margin: 8px 0;
    cursor: pointer;
    .user-icon {
      margin-right: 8px;
    }
  }
  .info-text {
    color: #999;
  }
  .meet-link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #eeee;
    padding: 15px;
    border-radius: 10px;
    span {
      font-size: 13px;
      font-weight: 600;
      color: #333;
    }
    .icon {
      color: #000;
    }
  }
  .permission-text {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    .icon {
      color: #eee;
      font-size: 1.3rem;
      margin-right: 8px;
    }
    .small-text {
      font-size: 0.8rem;
      font-weight: 400;
      margin: 1em 0;
    }
  }
  .small-text {
    font-size: 15px;
    margin: 0;
    color: #999;
  }
`;

const MeetingInfo = ({ setMeetingInfoPopup, url, }) => {
  return (
    <MeetingInfoBlock>
      <div className="meeting-header">
        <h3>Your meeting is ready</h3>
        <FontAwesomeIcon
          className="icon"
          icon={faTimes}
          onClick={() => {
            setMeetingInfoPopup(false);
          }}
        />
      </div>
      <button className="add-people-btn">
        <FontAwesomeIcon className="user-icon" icon={faUser} />
        Copy this ID
      </button>
      <p className="info-text">
        Or share the meeting link with others you want in the meeting
      </p>
      <div className="meet-link">
        <span>{url}</span>
        <FontAwesomeIcon
          className="icon"
          icon={faCopy}
          onClick={() => navigator.clipboard.writeText(url)}
        />
      </div>
      <div className="permission-text">
        <FontAwesomeIcon className="icon" icon={faShieldAlt} />
        <p className="small-text">
          People who use this meeting Code must get your permission before they
          can join.
        </p>
      </div>
    </MeetingInfoBlock>
  );
};

export default MeetingInfo;